var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reaction-preview-wrapper"},[_c('i',{staticClass:"icon-preview",class:[_vm.weight, _vm.icon],style:({color: _vm.color}),attrs:{"name":"icon-preview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }